import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './product-brand-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.object
}

const defaultProps = {
  hiddenColumns : [],
  isLoading     : false
}

/**
 * Table to display Product Brand columns
 * @param {Array<Object>} data - array of product brand objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const ProductBrandTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  rowButtonProps
}) => {
  const {
    handleEnableBrand,
    handleDisableBrand,
    handleOpenUpdateModal
  } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    handleEnableBrand,
    handleDisableBrand,
    handleOpenUpdateModal
  }), [
    handleEnableBrand,
    handleDisableBrand,
    handleOpenUpdateModal
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

ProductBrandTable.propTypes    = propTypes
ProductBrandTable.defaultProps = defaultProps

export default ProductBrandTable
